import state from './moduleDiversityState'
import mutations from './moduleDiversityMutations'
import actions from './moduleDiversityActions'
import getters from './moduleDiversityGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}